/* 


@PRAKT


   _____________________________________________________________

   |
   | DRAWER
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class Drawer {
    constructor( ref_) {
        this.ref = ref_;
        this.status = false;
        this.init();
    }

    init() {
        this.content = this.ref.nextElementSibling;
        this.headerClick();
    }

    headerClick() {
        this.ref.addEventListener( 'click', () => {
            if( !this.status ) this.open();
            else this.close();
            this.status = !this.status;
        } );
    }

    open() {
        this.ref.classList.add( 'active' );
        gsap.to( this.content, {
            duration: 1,
            ease: 'power3.inOut',
            height: 'auto',
            opacity: 1
        } );
    }

    close() {
        this.ref.classList.remove( 'active' );
        gsap.to( this.content, {
            duration: 1,
            ease: 'power3.inOut',
            height: 0,
            opacity: 0
        } );
    }
}